<template>
  <div class="pb-5">
    <Button icon="fas fa-trash-alt" :buttonStyle="{ color: 'red' }" :label="$t('remove')" @click="remove" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Button from '@/shared/components/Button'
import ContentMixin from '@/components/sidenav/landing/shared/ContentMixin.js'
import Mixin from '@/components/Mixin'

export default {
  name: 'HeroSparkBannerSideNavContentTab',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.herospark-banner-nav.content' },
  mixins: [ContentMixin, Mixin],
  components: { Button },
  computed: {
    ...mapGetters('funnels', ['hasFeature']),
  },
  methods: {
    ...mapActions('landing', ['removeHeroSparkBanner']),
    remove() {
      if (this.isFromFunnel && !this.hasFeature('funnels_banner_removal')) {
        window.open(`https://${process.env.VUE_APP_FUNNEL_URL}/my-account/plans`, '_blank')
        return
      }
      this.removeHeroSparkBanner({ id: this.id })
    },
  },
}
</script>
